var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.selectedValue,"items":_vm.items,"attach":"","label":_vm.label,"item-text":_vm.itemText,"item-value":_vm.itemValue,"clearable":_vm.clearable,"disabled":_vm.disabled},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }